<ng-container *ngIf="context?.id">
  <div>{{ context.row.regionName }}</div>
  <div>{{ context.row.ags }}</div>
</ng-container>
